

const CookiePolicy = () => {
  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white p-8 sm:p-10 rounded-lg shadow-md">
          
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">
            Cookie Policy
          </h1>
          

          <div className="space-y-6 text-gray-700 leading-relaxed">
            <p>
              La presente Cookie Policy ha lo scopo di illustrare in modo specifico e trasparente la nostra politica sui cookie, in linea con il nostro impegno per la tutela della privacy degli utenti.
            </p>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-3">
                1. Cosa sono i Cookie
              </h2>
              <p>
                I cookie sono piccoli file di testo che i siti visitati dagli utenti inviano ai loro terminali (solitamente al browser), dove vengono memorizzati per essere poi ritrasmessi agli stessi siti alla successiva visita del medesimo utente.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-3">
                2. Tipologie di Cookie Utilizzati da Questo Sito
              </h2>
              <p>
                Per garantire la massima protezione della privacy e offrire un'esperienza di navigazione pulita e senza tracciamenti, abbiamo fatto una scelta precisa:
              </p>
              <div className="my-4 p-4 border-l-4 border-blue-500 bg-blue-50">
                <p className="font-semibold text-blue-800 text-lg">
                  Questo sito web non utilizza alcun tipo di cookie.
                </p>
              </div>
              <p>
                Nello specifico, sul nostro sito <strong>NON TROVERAI</strong>:
              </p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li><strong>Cookie tecnici:</strong> Non utilizziamo cookie per salvare preferenze o gestire sessioni.</li>
                <li><strong>Cookie di analisi (analytics):</strong> Non utilizziamo cookie per raccogliere statistiche.</li>
                <li><strong>Cookie di profilazione:</strong> Non utilizziamo cookie per creare profili utente.</li>
                <li><strong>Cookie di terze parti:</strong> Non sono presenti servizi esterni che installano cookie.</li>
              </ul>
              <p className="mt-4">
                La navigazione su questo sito è quindi completamente anonima dal punto di vista del tracciamento tramite cookie.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-3">
                3. Gestione dei Cookie tramite le Impostazioni del Browser
              </h2>
              <p>
                Anche se il nostro sito non utilizza cookie, ti informiamo che puoi gestire e disabilitare i cookie per qualsiasi sito web modificando le impostazioni del tuo browser. Qui di seguito trovi i link alle guide per i browser più comuni:
              </p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 hover:underline">Google Chrome</a></li>
                <li><a href="https://support.mozilla.org/it/kb/Gestione%20dei%20cookie" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 hover:underline">Mozilla Firefox</a></li>
                <li><a href="https://support.microsoft.com/it-it/windows/eliminare-e-gestire-i-cookie-168dab11-0753-043d-7c16-ede5947fc64d" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 hover:underline">Microsoft Edge</a></li>
                <li><a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 hover:underline">Apple Safari</a></li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-3">
                4. Contatti
              </h2>
              <p>
                Per qualsiasi ulteriore informazione, si prega di fare riferimento alla nostra cookie policy o di contattare il Titolare del Trattamento ai recapiti ivi indicati.
              </p>
            </section>

          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;